import { OfferTypeFilter, Reward } from '@/models';
import { AccountManagementEvent, AccountPageLoadEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardCard',
})
export default class CmgRewardCard extends Vue {
  @Prop({ type: Object, required: true })
  reward!: Reward;
  hover = false;

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get rewardStarUrl(): string {
    return this.$services.reward.getRewardStarUrl(this.reward, this.hover);
  }

  get pointsClassObject() {
    return { bold: this.reward.points <= this.$services.reward.getPointsBalance() };
  }

  get isFoodReward(): boolean {
    return this.reward.offerType == OfferTypeFilter.Food;
  }

  onClickRewardStar(event: any) {
    const action = this.reward.isFavorite ? AnalyticsEventAction.RewardUnfavorited : AnalyticsEventAction.RewardFavorited;
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsStore,
      action: this.reward.title + action,
      label: AnalyticsEventLabel.RewardStoreSpecific + this.reward.title,
    });

    if(action == AnalyticsEventAction.RewardFavorited) {
      this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.RewardsFavorited, [], this.reward.title));
    } 

    event.stopPropagation();
    this.$services.reward.toggleFavoriteStatus(this.reward);
  }

  onClickRewardTile(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsStore,
      action: this.reward.title + AnalyticsEventAction.RewardTileClick,
      label: AnalyticsEventLabel.RewardStoreSpecific + this.reward.title,
    });
    this.sendAnalyticsEvents();
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('rewardDetail', true, { reward: this.reward });
    this.$services.ui.firstFocus();
  }

  sendAnalyticsEvents() {
    this.$services.analytics.send(new AccountPageLoadEvent('rewards-redemption', this.reward));  
    this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.RewardsViewed, [], this.reward.title ?? ''));
  }
}
